const blackoutDates = [
  new Date('December 31, 2019').getTime()
]

export default blackoutDates;



// WEBPACK FOOTER //
// ./src/constants/blackoutDates.js